import type { Ref } from "react";

// This function emulates "focus" attributes for React DOM elements
export function createFocusHandler<E extends HTMLElement>(focused: boolean | undefined): Ref<E> | undefined {
  if (focused === undefined) {
    return undefined;
  }

  return (element: E | null) => {
    if (element && element.matches(":focus") !== focused) {
      if (focused) {
        element.focus();
      } else {
        element.blur();
      }
    }
  };
}
